import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import AdminDashboard from "../components/Admin/AdminDashboard/AdminDashboard";

import AdminAllCourseManagement from "../components/Admin/AdminAllCourseManagement/AdminAllCourseManagement";
import AdminPublishedCourseManagement from "../components/Admin/AdminPublishedCourseManagement/AdminPublishedCourseManagement";
import AdminPendingCourseManagement from "../components/Admin/AdminPendingCourseManagement/AdminPendingCourseManagement";
import AdminRejectedCourseManagement from "../components/Admin/AdminRejectedCourseManagement/AdminRejectedCourseManagement";

import AdminAllTutorManagement from "../components/Admin/AdminAllTutorManagement/AdminAllTutorManagement";
import AdminPublishedTutorManagement from "../components/Admin/AdminPublishedTutorManagement/AdminPublishedTutorManagement";
import AdminPendingTutorManagement from "../components/Admin/AdminPendingTutorManagement/AdminPendingTutorManagement";
import AdminRejectedTutorManagement from "../components/Admin/AdminRejectedTutorManagement/AdminRejectedTutorManagement";

import AdminStudentManagement from "../components/Admin/AdminStudentManagement/AdminStudentManagement";
import AdminStudentCertificates from "../components/Admin/AdminStudentCertificates/AdminStudentCertificates";
import AdminFinalAssignments from "../components/Admin/AdminFinalAssignments/AdminFinalAssignments";
import AdminPlatformAnalytics from "../components/Admin/AdminPlatformAnalytics/AdminPlatformAnalytics";
import AdminStudentPayments from "../components/Admin/AdminStudentPayments/AdminStudentPayments";
import AdminInternship from "../components/Admin/AdminInternship/AdminInternship";
import AdminChats from "../components/Admin/AdminChats/AdminChats";
import AdminPauseChats from "../components/Admin/AdminPauseChats/AdminPauseChats";

import NotFound from "../components/NotFound/NotFound";

const AdminRoutes = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="dashboard" replace />} />

      <Route path="dashboard" element={<AdminDashboard />} />

      <Route path="all-courses" element={<AdminAllCourseManagement />} />

      {/* Published Courses */}
      <Route path="course-published">
        <Route index element={<AdminPublishedCourseManagement />} />
        <Route path=":courseId" element={<AdminPublishedCourseManagement />} />
      </Route>

      {/* Pending Courses */}
      <Route path="course-pending">
        <Route index element={<AdminPendingCourseManagement />} />
        <Route path=":courseId" element={<AdminPendingCourseManagement />} />
      </Route>

      {/* Rejected Courses */}
      <Route path="course-rejected">
        <Route index element={<AdminRejectedCourseManagement />} />
        <Route path=":courseId" element={<AdminRejectedCourseManagement />} />
      </Route>

      <Route path="all-tutor" element={<AdminAllTutorManagement />} />

      {/* Published Tutors */}
      <Route path="tutor-published">
        <Route index element={<AdminPublishedTutorManagement />} />
        <Route path=":tutorId" element={<AdminPublishedTutorManagement />} />
      </Route>

      {/* Pending Tutors */}
      <Route path="tutor-pending">
        <Route index element={<AdminPendingTutorManagement />} />
        <Route path=":tutorId" element={<AdminPendingTutorManagement />} />
      </Route>

      {/* Rejected Tutors */}
      <Route path="tutor-rejected">
        <Route index element={<AdminRejectedTutorManagement />} />
        <Route path=":tutorId" element={<AdminRejectedTutorManagement />} />
      </Route>

      <Route path="student-management" element={<AdminStudentManagement />} />
      <Route
        path="student-certificates"
        element={<AdminStudentCertificates />}
      />
      <Route path="assignments" element={<AdminFinalAssignments />} />
      <Route path="platform-analytics" element={<AdminPlatformAnalytics />} />
      <Route path="student-payments" element={<AdminStudentPayments />} />
      <Route path="internship" element={<AdminInternship />} />
      <Route path="chats" element={<AdminChats />} />
      <Route path="paused-chats" element={<AdminPauseChats />} />

      {/* Catch all wrong admin routes */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AdminRoutes;
